import React, { Component } from 'react'
import { Route, withRouter } from 'react-router'
import { connect } from 'react-redux'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import DateContainer from 'components/date-container/date-container'
import SmoothCollapse from 'react-smooth-collapse'

import moment from 'moment'

import MeetingReportingItem from './meeting-reporting-item'

import { MainContext } from 'context'

import { forIn } from 'lodash'
import copy from 'fast-copy'

import SectionControls from 'components/controls/section-controls'

import ListContainer from 'components/list-container/list-container'

import { getAccountMeetings } from 'state/actions'

import { CSVLink } from "react-csv"

import { 
	stripHtml,
	doSort
} from 'utils'

class MeetingReporting extends Component {
	state = {
		searchTerm: '',
		showingFilters: false,
		loading: true,
		filters: {},
		openDatePicker: null,
		csvData: []
	}

	allAccountMeetings = []

	UNSAFE_componentWillMount() {
		this.props.getAccountMeetings(this.context.account.id, _ => {
			this.setState({
				loading: false
			})
		})		
	}

	onSearchTermChange = value => {
		this.setState({
			searchTerm: value
		})
	}

	assessCloseDatePickers = _ => {
		this.setState({
			openDatePicker: null
		})
	}

	toggleShowFilters = _ => {
		this.setState({
			showingFilters: !this.state.showingFilters
		})
	}

	getSubtitle = meetings => {
		const totalMeetings = meetings.length
		let uniqueLocations = []

		if(!totalMeetings){
			return `There haven't been any meetings just yet.`
		}

		meetings.forEach(meeting => {
			if(meeting.location && uniqueLocations.indexOf(meeting.location) == -1){
				uniqueLocations.push(meeting.location)
			}
		})

		return `There ${totalMeetings.length > 1 ? 'have' : 'has' } been <strong>${totalMeetings}</strong> meeting${totalMeetings > 1 ? 's' : ''}, in <strong>${uniqueLocations.length}</strong> location${ uniqueLocations.length > 1 ? 's' : '' }.`
	}

	export = list => {
		const csvData = [['Date', 'Project', 'Location', 'Organiser', 'Attending Organisations', 'Purpose', 'Contact Type', 'Notes']]

		list.forEach(item => {
			csvData.push([
				item.start_date ? item.start_date : '(No start date)',
				item.project ? item.project.name : '(No project)',
				item.location ? item.location : '(No location)',
				item.stakeholder ? item.stakeholder : '(No organisation)',
				item.stakeholders ? item.stakeholders : '(No attending organisations)',
				item.purposes ? item.purposes  : '(No purposes)',
				item.contact_type ? item.contact_type.name : '(No contact type)',
				item.notes ? stripHtml(item.notes) : '(No notes)'
			])
		})

		this.setState({
			csvData
		}, _ => {
			this.csvLink.link.click()
		})
	}

	handleFilterChange = (value, key) => {
		const filters = copy(this.state.filters)

		if(filters[key] && filters[key] == value){
			filters[key] = null
		}else{
			filters[key] = value
		}

		this.setState({
			filters,
			openDatePicker: null
		})
	}

	formatData = items => {
		const {
			allProjects,
			allPurposes,
			allStakeholders
		} = this.props

		const {
			filters
		} = this.state

		const {
			account
		} = this.context

		const data = []

		items.forEach(item => {
			const formattedItem = {
				item,
				start_date: moment(item.start_date).format('Do MMMM, YYYY'),
				project: null,
				contact_type: null,
				purpose: null,
				location: item.location,
				attendees: item.number_of_attendees,
			}

			let shouldPushItem = true

			forIn(filters, (value, key) => {
				let tempShouldPush = true

				if(value){
					switch(key){
						case 'project':
							tempShouldPush = item.project_id === value
							break
						case 'location':
							tempShouldPush = item.location === value
							break
						case 'organisation':
							tempShouldPush = (item.stakeholders && item.stakeholders.indexOf(value) !== -1) || (item.stakeholder_id && item.stakeholder_id == value)
							break
						case 'contact type':
							tempShouldPush = item.contact_type_id === value
							break
						case 'purpose':
							tempShouldPush = (item.purposes && item.purposes.indexOf(value) !== -1)
							break
						case 'start_date':
							tempShouldPush = moment(item.start_date).isAfter(moment(value).subtract(1, 'days'))
							break
						case 'end_date':
							tempShouldPush = moment(item.start_date).isBefore(moment(value).add(1, 'days'))
							break
					}
				}

				if(!tempShouldPush){
					shouldPushItem = false
				}
			})

			if(!shouldPushItem){
				return 
			}

			let project = null

			if(item.project_id){
				project = allProjects[item.project_id]

				if(project){
					formattedItem.project = project
				}
			}

			if(item.contact_type_id){
				const contactType = account.contact_types.find(loopedContactType => {
					return loopedContactType.id === item.contact_type_id
				})

				if(contactType){
					formattedItem.contact_type = contactType
				}
			}

			if(item.purposes && item.purposes.length){
				let purposesString = ''

				item.purposes.forEach((purposeId, index) => {
					const purposeObject = allPurposes[purposeId]

					if(purposeObject){
						if(index){
							purposesString += ', '
						}

						purposesString += purposeObject.name
					}
				})

				formattedItem.purposes = purposesString
			}

			const stakeholderIds = item.stakeholders ? [...item.stakeholders] : []

			if(item.stakeholder_id && stakeholderIds.indexOf(item.stakeholder_id) == -1){
				stakeholderIds.push(item.stakeholder_id)
			}

			if(stakeholderIds.length){
				let stakeholdersString = ''

				stakeholderIds.forEach((stakeholderId, index) => {
					const stakeholderObject = allStakeholders[stakeholderId]

					if(!stakeholderObject || !stakeholderObject.organisation_name){
						return
					}

					if(stakeholderObject){
						if(index){
							stakeholdersString += ', '
						}

						stakeholdersString += stakeholderObject.organisation_name
					}
				})

				formattedItem.stakeholders = stakeholdersString
			}

			if(item.stakeholder_id){
				const stakeholder = allStakeholders[item.stakeholder_id]

				if(stakeholder){
					formattedItem.stakeholder = stakeholder.organisation_name ? stakeholder.organisation_name : (stakeholder.first_name+' '+stakeholder.last_name)
				}
			}

			data.push(formattedItem)
		})

		return data
	}

	getValues = key => {
		const {
			allProjects,
			allStakeholders,
			allPurposes
		} = this.props

		const {
			account
		} = this.context

		let values = []

		switch(key){
			case 'project':
				this.allAccountMeetings.forEach(meeting => {
					if(meeting.project_id){
						const projectIfExisting = values.find(value => {
							return value.id === meeting.project_id
						})

						if(!projectIfExisting){
							const project = allProjects[meeting.project_id]

							if(project){
								values.push({
									name: project.name,
									id: project.id
								})
							}
						}
					}
				})
				break
			case 'location':
				this.allAccountMeetings.forEach(meeting => {
					if(meeting.location){
						const locationIfExisting = values.find(value => {
							return value.id === meeting.location
						})

						if(!locationIfExisting){
							values.push({
								name: meeting.location,
								id: meeting.location
							})
						}
					}
				})
				break
			case 'organisation':
				this.allAccountMeetings.forEach(meeting => {
					const stakeholderIds = meeting.stakeholders ? [...meeting.stakeholders] : []

					if(meeting.stakeholder_id){
						stakeholderIds.push(meeting.stakeholder_id)
					}

					stakeholderIds.forEach(stakeholderId => {
						const stakeholderIfExisting = values.find(value => {
							return value.id === stakeholderId
						})

						if(!stakeholderIfExisting){
							const stakeholder = allStakeholders[stakeholderId]

							if(stakeholder){
								values.push({
									name: stakeholder.organisation_name ? stakeholder.organisation_name : (stakeholder.first_name+' '+stakeholder.last_name),
									id: stakeholder.id
								})
							}
						}
					})
				})

				break
			case 'contact type':
				this.allAccountMeetings.forEach(meeting => {
					if(meeting.contact_type_id){
						const contactTypeIfExisting = values.find(value => {
							return value.id === meeting.contact_type_id
						})

						if(!contactTypeIfExisting){
							let contactType = account.contact_types ? account.contact_types.find(contact_type => {
								return contact_type.id === meeting.contact_type_id
							}) : null

							if(contactType){
								values.push({
									name: contactType.name,
									id: contactType.id
								})
							}
						}
					}
				})

				break
			case 'purpose':
				this.allAccountMeetings.forEach(meeting => {
					if(meeting.purposes && meeting.purposes.length){
						meeting.purposes.forEach(purposeId => {
							const purposeIfExisting = values.find(value => {
								return value.id === purposeId
							})

							if(!purposeIfExisting){
								const purposeObject = allPurposes[purposeId]

								if(purposeObject){
									values.push({
										name: purposeObject.name,
										id: purposeObject.id
									})
								}
							}
						})
					}
				})
				break
		}

		return values
	}

	toggleDatePicker = index => {
		if(this.state.openDatePicker === index){
			this.setState({
				openDatePicker: null
			})
		}else{
			this.setState({
				openDatePicker: index
			})
		}
	}

	render() {
		const {
			allMeetings
		} = this.props

		const {
			searchTerm,
			showingFilters,
			filters,
			openDatePicker,
			csvData
		} = this.state

		const {
			account
		} = this.context

		this.allAccountMeetings = []

		forIn(allMeetings, meeting => {
			if(meeting.account_id === account.id){
				this.allAccountMeetings.push(meeting)
			}
		})

		const list = this.formatData(this.allAccountMeetings)
		const unit = MeetingReportingItem
		const columns = [
			{
				label: 'Date',
				slug: 'date',
				getter: object => {
					return object.item.start_date
				}
			},{
				label: 'Project',
				slug: 'project',
				getter: object => {
					return object.project ? object.project.name : ''
				}
			},{
				label: 'Location',
				slug: 'location',
				getter: object => {
					return object.location
				}
			},{
				label: 'Attending organisations',
				slug: 'organisation',
				getter: object => {
					return object.stakeholder ? object.stakeholder : ''
				}
			},{
				label: 'Purposes',
				slug: 'purposes',
				getter: object => {
					return object.purposes ? object.purposes : ''
				}
			},{
				label: 'Contact type',
				slug: 'contact_type',
				getter: object => {
					return object.contact_type ? object.contact_type.name : ''
				}
			}
		]

		const checkboxProps = [
			{
				label: 'Show filters',
				isChecked: showingFilters,
				callback: this.toggleShowFilters
			}
		]

		const buttonProps = [
			{
				size: 'big',
				level: 'high',
				label: showingFilters ? 'Export selection' : 'Export all',
				icon: 'fe-users',
				callback: _ => { this.export(list) }
			}
		]

		const filterOptions = {
			dates: [
				{
					key: 'start_date',
					label: 'Start date',
					type: 'date'
				},
				{
					key: 'end_date',
					label: 'End date',
					type: 'date'
				}
			],
			selects: [
				{
					key: 'project',
					type: 'select',
				},{
					key: 'location',
					type: 'select'
				},{
					key: 'organisation',
					type: 'select'
				},{
					key: 'contact type',
					type: 'select'
				},{
					key: 'purpose',
					type: 'select'
				}
			]
		}

		const selectBoxCount = filterOptions.selects.length

		return (
			<div 
				className="page-container"
				onClick={this.assessCloseDatePickers}
			>
				<div className={"page-container-inner"}>	
					<header className="main-header">
						<h1>
							Reporting
						</h1>
                        <div className="sub-title-area">
                            <span dangerouslySetInnerHTML={{ __html: this.getSubtitle(this.allAccountMeetings) }} />
                        </div>
					</header>
					<main>
						<CSVLink
							data={csvData}
							filename={'Hassl Meetings Report, '+moment().format('Do MMMM')+'.csv'}
							className="hidden"
							ref={ref => this.csvLink = ref}
							target="_blank"
						/>
						<SectionControls 
							searchTerm={searchTerm} 
							onSearchTermChange={this.onSearchTermChange} 
							checkboxProps={checkboxProps}
							buttons={buttonProps}
						/>
						<SmoothCollapse 
							expanded={showingFilters}
							allowOverflowWhenOpen={true}
						>
							<div className={"report-filter select-count-"+selectBoxCount}>
								<div>
									{ filterOptions.dates.map((filterOption, index) => {
										return (
											<div 
												key={filterOption.key}
												className={'option-type-'+filterOption.type}
												onClick={e => e.stopPropagation()}
											>
												<DateContainer
													isEdit={true}
													isOpen={openDatePicker === index}
													toggleCallback={_ => {this.toggleDatePicker(index)}}
													selectCallback={value => {this.handleFilterChange(value, filterOption.key)}} 
													initialMonth={new Date}
													selectedDate={filters[filterOption.key] ? filters[filterOption.key] : null}
													label={filterOption.label}
													allowPast={true}
												/>
											</div>
										)
									})}
								</div>
								<div>
									{ filterOptions.selects.map(filterOption => {
										const values = this.getValues(filterOption.key)

										return (
											<div 
												key={filterOption.key}
												className={'option-type-'+filterOption.type}
											>
												<DropdownMenu 
													isObjects={true} 
													selectableItems={doSort(values, 'alpha', 'name')} 
													selectedItemId={filters[filterOption.key] ? filters[filterOption.key] : null} 
													handleChange={value => {this.handleFilterChange(value, filterOption.key)}} 
													parentType={filterOption.key}
												/>
											</div>
										)
									})}
								</div>
							</div>
						</SmoothCollapse>
						<ListContainer
							items={list}
							unit={unit}
							emptyTitle={`Nothing to show here.`}
							emptyCopy={`You haven't got any meetings just yet.`}
							type={'meeting'}
							isGrid={false}
							canSort={true}
							shouldBlockTransition={false}
							columns={columns}
							searchTerm={searchTerm}
						/>
					</main>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		allMeetings: state.account.entities.meetings,
		allProjects: state.account.entities.projects,
		allPurposes: state.account.entities.purposes,
		allStakeholders: state.account.entities.stakeholders
	}
}

export default withRouter(connect(mapStateToProps, {
	getAccountMeetings
})(MeetingReporting))

MeetingReporting.contextType = MainContext